import { Component } from '@angular/core';

@Component({
  selector: 'app-about-us',
  templateUrl: './who-we-are.component..html',
  styleUrl: './who-we-are.component.css'
})
export class WhoWeAreComponent {
  teamMembers = [
    { name: "Schelly Marlatt", role: "Gwinnett Clean & Beautiful Executive Director", email: "smarlatt@gwinnettcb.org", website: "https://gwinnettcb.org" },
    { name: "Brenda McDaniel", role: "Green and Healthy Schools Program Manager", email: "Brenda.O.McDaniel@gcpsk12.org", website: "https://gwinnettcb.org" },
    { name: "Jessica Holden", role: "Gwinnett County Public Schools 6-12 Science Director", email: "Jessica.holden@gcpsk12.org", website: "https://www.gcpsk12.org" },
  ];
}
